import { gql } from '@apollo/client';

export const CREATE_PIPELINE_RUN = gql`
  mutation CreatePipelineRun($input: CreatePipelineRunInput!) {
    createPipelineRun(input: $input) {
      id
      org_id
      case_id
      created_date
      created_by
      pipeline_type
      document_count
      documents
      status
    }
  }
`;
